export default __webpack_public_path__ + "static/media/amp-logo.c2fead87.png";